// /* eslint-disable react-hooks/exhaustive-deps */
// import React, { useState, useEffect } from "react";
// import { Table, message, Modal, Input } from "antd";
// import axios from "axios";
// import moment from "moment";
// import "@fortawesome/fontawesome-free/css/all.min.css";
// import { useNavigate } from "react-router-dom";


// const OrderHistory = () => {
//     const [servicesData, setServicesData] = useState([]);
//     const [filteredData, setFilteredData] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [cancelModal, setCancelModal] = useState({ visible: false, orderId: null });
//     const [cancelReason, setCancelReason] = useState("");
//  const navigate = useNavigate();
//     const authData = localStorage.getItem("auth");
//     const authObject = JSON.parse(authData);
//     const token = authObject?.accessToken;

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const response = await axios.get("http://localhost:4000/user/bookedHistory", {
//                     headers: { Authorization: `Bearer ${token}` },
//                 });

//                 const apiData = response.data.data.map((item) => ({
//                     key: item._id,
//                     name: `${item.firstName} ${item.lastName}`,
//                     email: item.email,
//                     phone: item.phoneNumber,
//                     service: item.serviceName,
//                     address: item.address,
//                     mapAddress: item.mapAddress,
//                     status: item.status,
//                     createdAt: item.createdAt,
//                 }));

//                 setServicesData(apiData);
//                 setFilteredData(apiData);
//             } catch (error) {
//                 console.error("Error fetching data:", error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, []);

//     const handleCancelBooking = async () => {
//         try {
//             await axios.patch(
//                 `http://localhost:4000/user/cancelBooking/${cancelModal.orderId}`,
//                 { reason: cancelReason },
//                 {
//                     headers: { Authorization: `Bearer ${token}` },
//                 }
//             );

//             message.success("Booking cancelled successfully");

//             const updatedData = servicesData.map((service) =>
//                 service.key === cancelModal.orderId ? { ...service, status: "Cancelled" } : service
//             );

//             setServicesData(updatedData);
//             setFilteredData(updatedData);
//         } catch (error) {
//             message.error("Failed to cancel booking");
//             console.error("Error cancelling booking:", error);
//         } finally {
//             setCancelModal({ visible: false, orderId: null });
//             setCancelReason("");
//         }
//     };

//     const columns = [
//         {
//             title: "Name",
//             dataIndex: "name",
//             key: "name",
//         },
//         {
//             title: "Email",
//             dataIndex: "email",
//             key: "email",
//         },
//         {
//             title: "Phone",
//             dataIndex: "phone",
//             key: "phone",
//         },
//         {
//             title: "Service",
//             dataIndex: "service",
//             key: "service",
//         },
//         {
//             title: "Address",
//             dataIndex: "address",
//             key: "address",
//         },
//         {
//             title: "Date & Time",
//             dataIndex: "createdAt",
//             key: "createdAt",
//             render: (text) => (
//                 <span>
//                     {moment(text).format("MMMM Do YYYY, h:mm A")} <br />
//                     ({moment(text).format("dddd")})
//                 </span>
//             ),
//         },
//         {
//             title: "Status",
//             dataIndex: "status",
//             key: "status",
//             render: (status) => (
//                 <span className="inline-block py-2 px-4 rounded-lg bg-gray-100 text-center text-sm">
//                     {status}
//                 </span>
//             ),
//         },
//         {
//             title: "Action",
//             key: "action",
//             render: (_, record) => {
//                 if (record.status === "Cancelled") return null;

//                 return (
//                     <div className="flex gap-2">
//                         {record.status !== "Completed" && (
//                             <button
//                                 className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-700"
//                                 onClick={() => setCancelModal({ visible: true, orderId: record.key })}
//                             >
//                                 Cancel
//                             </button>
//                         )}

//                         {record.status === "Completed" && (
//                             <button
//                                 className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600"
//                                 // onClick={() => window.open(`/feedback?orderId=${record.key}`, "_blank")}
//                             //  onClick={() => navigate("/feedback")}
//                               onClick={() => navigate(`/feedback?orderId=${record.key}`)} // ✅ single-tab navigation

//                            >
//                                 Give Feedback
//                             </button>
//                         )}
//                     </div>
//                 );
//             },
//         },
//     ];

//     return (
//         <div className="bg-gray-100 min-h-screen py-6 px-4 md:px-8">
//             <div className="bg-white p-6 rounded-lg shadow-lg">
//                 <h3 className="mb-4 text-xl font-semibold text-center text-red-800 md:text-2xl">Orders History</h3>

//                 {/* Orders Table */}
//                 <div className="overflow-x-auto">
//                     <Table
//                         columns={columns}
//                         dataSource={filteredData}
//                         loading={loading}
//                         pagination={{
//                             pageSize: 10,
//                             total: filteredData.length,
//                             showSizeChanger: false,
//                             defaultCurrent: 1,
//                         }}
//                         scroll={{ x: true }}
//                     />
//                 </div>
//             </div>

//             {/* Cancel Modal */}
//             <Modal
//                 title="Cancel Booking"
//                 open={cancelModal.visible}
//                 onOk={handleCancelBooking}
//                 onCancel={() => setCancelModal({ visible: false, orderId: null })}
//                 okText="Confirm Cancel"
//                 okButtonProps={{ danger: true }}
//             >
//                 <p>Are you sure you want to cancel this booking?</p>
//                 <Input.TextArea
//                     rows={3}
//                     placeholder="Optional: Reason for cancellation"
//                     value={cancelReason}
//                     onChange={(e) => setCancelReason(e.target.value)}
//                 />
//             </Modal>
//         </div>
//     );
// };

// export default OrderHistory;
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Table, message, Modal, Input } from "antd";
import axios from "axios";
import moment from "moment";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useNavigate } from "react-router-dom";

const OrderHistory = () => {
  const [activeOrders, setActiveOrders] = useState([]);
  const [cancelledOrders, setCancelledOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cancelModal, setCancelModal] = useState({ visible: false, orderId: null });
  const [cancelReason, setCancelReason] = useState("");

  const navigate = useNavigate();
  const authData = localStorage.getItem("auth");
  const authObject = JSON.parse(authData);
  const token = authObject?.accessToken;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${API_BASE}/user/bookedHistory`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const allOrders = res.data.data.map((item) => ({
          key: item._id,
          name: `${item.firstName} ${item.lastName}`,
          email: item.email,
          phone: item.phoneNumber,
          service: item.serviceName,
          address: item.address,
          mapAddress: item.mapAddress,
          status: item.status,
          createdAt: item.createdAt,
        }));

        // ✅ Split orders by status
        setActiveOrders(allOrders.filter((o) => o.status !== "Cancelled"));
        setCancelledOrders(allOrders.filter((o) => o.status === "Cancelled"));
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
const API_BASE = process.env.REACT_APP_API_BASE;

  const handleCancelBooking = async () => {
    try {
      await axios.patch(
        `${API_BASE}/user/cancelBooking/${cancelModal.orderId}`,
        { reason: cancelReason },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      message.success("Booking cancelled successfully");

      // ✅ Move from active → cancelled
      const updatedActive = activeOrders.filter((o) => o.key !== cancelModal.orderId);
      const cancelledOrder = activeOrders.find((o) => o.key === cancelModal.orderId);
      if (cancelledOrder) {
        cancelledOrder.status = "Cancelled";
        setCancelledOrders([...cancelledOrders, cancelledOrder]);
      }
      setActiveOrders(updatedActive);
    } catch (error) {
      message.error("Failed to cancel booking");
      console.error("Error cancelling booking:", error);
    } finally {
      setCancelModal({ visible: false, orderId: null });
      setCancelReason("");
    }
  };

  const commonColumns = [
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Email", dataIndex: "email", key: "email" },
    { title: "Phone", dataIndex: "phone", key: "phone" },
    { title: "Service", dataIndex: "service", key: "service" },
    { title: "Address", dataIndex: "address", key: "address" },
    {
      title: "Date & Time",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => (
        <span>
          {moment(text).format("MMMM Do YYYY, h:mm A")} <br />({moment(text).format("dddd")})
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <span className="inline-block py-2 px-4 rounded-lg bg-gray-100 text-center text-sm">
          {status}
        </span>
      ),
    },
  ];

  const actionColumn = {
    title: "Action",
    key: "action",
    render: (_, record) => {
      if (record.status === "Cancelled") return null;

      return (
        <div className="flex gap-2">
          {record.status !== "Completed" && (
            <button
              className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-700"
              onClick={() => setCancelModal({ visible: true, orderId: record.key })}
            >
              Cancel
            </button>
          )}

          {record.status === "Completed" && (
            <button
              className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600"
              onClick={() => navigate(`/feedback?orderId=${record.key}`)}
            >
              Give Feedback
            </button>
          )}
        </div>
      );
    },
  };

  return (
    <div className="bg-gray-100 min-h-screen py-6 px-4 md:px-8">
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <h3 className="mb-4 text-xl font-semibold text-center text-red-800 md:text-2xl">
          Active Orders
        </h3>

        <div className="overflow-x-auto mb-10">
          <Table
            columns={[...commonColumns, actionColumn]}
            dataSource={activeOrders}
            loading={loading}
            pagination={{ pageSize: 8, showSizeChanger: false }}
            scroll={{ x: true }}
          />
        </div>

        <h3 className="mb-4 text-xl font-semibold text-center text-gray-800 md:text-2xl">
          Cancelled Orders
        </h3>

        <div className="overflow-x-auto">
          <Table
            columns={commonColumns}
            dataSource={cancelledOrders}
            loading={loading}
            pagination={{ pageSize: 8, showSizeChanger: false }}
            scroll={{ x: true }}
          />
        </div>
      </div>

      {/* Cancel Modal */}
      <Modal
        title="Cancel Booking"
        open={cancelModal.visible}
        onOk={handleCancelBooking}
        onCancel={() => setCancelModal({ visible: false, orderId: null })}
        okText="Confirm Cancel"
        okButtonProps={{ danger: true }}
      >
        <p>Are you sure you want to cancel this booking?</p>
        <Input.TextArea
          rows={3}
          placeholder="Optional: Reason for cancellation"
          value={cancelReason}
          onChange={(e) => setCancelReason(e.target.value)}
        />
      </Modal>
    </div>
  );
};

export default OrderHistory;
